import _taggedTemplateLiteral from "/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject;
import { css } from 'lit';
export default css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  :host {\n    display: block;\n    width: max-content;\n  }\n"])));
//# sourceMappingURL=styles.js.map